"use client";

import React from "react";
import { ArrowRight, CalendarCheck2 } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="consultationcta" data-nav="dark" className="relative overflow-hidden bg-sidebar py-16 text-sidebar-foreground sm:py-20 lg:py-24">
      {/* Subtle decorative grid/glow elements */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[600px] rounded-full bg-sidebar-accent/30 blur-3xl" />
        <div className="absolute -top-24 right-0 size-72 rounded-full bg-primary/10 blur-2xl" />
      </div>

      <div className="page-container relative z-10 mx-auto px-4 text-center sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-sidebar-border bg-sidebar-accent/50 px-3.5 py-1 text-xs font-medium text-sidebar-foreground">
            <CalendarCheck2 className="size-3.5 text-primary" />
            <span>Expert Technical Guidance</span>
          </div>

          <h2 className="font-default text-2xl font-bold tracking-tight text-sidebar-foreground sm:text-3xl md:text-4xl">
            Consult with an Antech HPLC Application Specialist
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-base text-sidebar-foreground/80 sm:text-lg">
            Receive dedicated advice on method development, system qualification, and instrumentation support tailored to your laboratory workflow.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="bg-primary text-primary-foreground shadow-md transition-transform hover:scale-[1.02] hover:bg-primary/90 focus-visible:ring-primary">
              <Link to="/ContactPage" className="inline-flex items-center gap-2 font-semibold">
                <span>Schedule Your HPLC Assessment</span>
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}